
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import HowXt from './HowXt.vue'
import { EnumWelcomeAskCompType } from '@xt/client/enums/activity/index'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg,
    HowXt
  }
})
export default class WelcomeAsk extends Vue {
  current: EnumWelcomeAskCompType = EnumWelcomeAskCompType.NoBasic
  tabList: EnumWelcomeAskCompType[] = [EnumWelcomeAskCompType.NoBasic, EnumWelcomeAskCompType.Uninsist, EnumWelcomeAskCompType.HowXt]

  get EnumWelcomeAskCompType() {
    return EnumWelcomeAskCompType
  }

  get options() {
    return {
      video: {
        url: 'https://testing-static.xuantong.cn/video/mov_bbb.mp4',
        pic: 'https://testing-file.xuantong.cn/images/origin/adf76360cd27fde7f1d8d70573600087.png'
      },
      screenshot: false,
      lang: 'zh-cn',
      autoplay: false
    }
  }

  onSelect(t: EnumWelcomeAskCompType) {
    if (this.current === t) return
    this.current = t
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
